<template>
  <div class="fixed-top menucontrol-scroll">
    <Banner />
    <ReviewTable />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import ReviewTable from "./components/ReviewTable.vue";
export default {
  components: {
    Banner,
    ReviewTable,
  },
};
</script>
